import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import { InfoItem } from 'src/components/elements';
import BasePopup from 'src/popups/BasePopup';

import styles from './AthenaPatientDetailsPopup.module.scss';

const AthenaPatientDetailsPopup = ({ data, onClose }) => (
  <BasePopup id="athena-patient-details" open onClose={onClose} title="Athena Patient Details">
    <div className={styles.grid}>
      <InfoItem title="First Name" content={data.firstName} textId="first-name" small />
      <InfoItem title="Last Name" content={data.lastName} textId="last-name" small />
      <InfoItem title="Sex" content={data.sex} textId="sex" small />
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem
        title="Date of Birth"
        content={data.dob ? moment(data.dob).format('MM/DD/YYYY') : '-'}
        textId="dob"
        small
      />
      <InfoItem
        title="Athena Patient ID"
        content={data.athenaPatientId}
        textId="athena-patient-id"
        small
      />
      <InfoItem title="Practice ID" content={data.athenaPracticeId} textId="practice-id" small />
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem title="Department ID" content={data.departmentId} textId="department-id" small />
    </div>
  </BasePopup>
);

AthenaPatientDetailsPopup.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func,
};

export default AthenaPatientDetailsPopup;
